export default __webpack_public_path__ + "static/open-sans-latin-400-normal-feb0d8644aca3df9fabf5e91ff7e9cb5.woff2";